
export const buildYourOwnValue: { [key: string]: number } = {
    // "050": 0.5,
    "075": 0.75,
    "100": 1,
    "150": 1.5,
    "200": 2,
    "300": 3,
    "500": 5,
};

export const startWithSettingValue: { [key: string]: number } = {
    "075": 0.75,
    "100": 1,
    "150": 1.5,
    "200": 2,
    // "250": 2.5,
    "300": 3,
    "500": 5,
};
/**
 * Fit a wanted size code to the sizes a style actually builds. The diamond journey
 * picks a size from the carat alone, before any style is chosen, so it can land on
 * one the setting does not offer.
 */
export const fitToAvailableSize = (wanted?: string, availableCodes?: string[]) => {
    if (!wanted || !availableCodes?.length || availableCodes.includes(wanted)) {
        return wanted;
    }
    return availableCodes.reduce((nearest, code) =>
        Math.abs(+code - +wanted) < Math.abs(+nearest - +wanted) ? code : nearest
    );
};

export const findNearestValue = (targetValue: number,isStartWithSetting?:boolean) => {
    let closestKey = "";
    let closestDifference = Infinity;
    const centerDiamondSizeValue = isStartWithSetting ? startWithSettingValue : buildYourOwnValue ;
// Iterate through each key in the object
    for (const key in centerDiamondSizeValue) {
        if (Object.prototype.hasOwnProperty.call(centerDiamondSizeValue, key)) {
            const value = centerDiamondSizeValue[key];
            const difference = Math.abs(value - targetValue);

            // Check if this difference is smaller than the current smallest difference
            if (difference < closestDifference) {
                closestDifference = difference;
                closestKey = key;
            }
        }
    }
    return closestKey;
}
